import { useEffect, useRef } from 'react';
import type { LogEntry } from '../session/Session';

export function EventLog({ entries }: { entries: LogEntry[] }) {
  const list = useRef<HTMLOListElement | null>(null);
  // Scroll only the log itself, never the page.
  useEffect(() => { if (list.current) list.current.scrollTop = list.current.scrollHeight; }, [entries.length]);
  return (
    <section className="panel log" aria-label="Game log">
      <h2 className="panel-title">Log</h2>
      {entries.length === 0 ? <p className="muted">Moves will appear here.</p> : (
        <ol className="log-list" ref={list}>
          {entries.map(e => (
            <li key={e.id}><span className="log-rev">{e.revision}</span>{e.message}</li>
          ))}
        </ol>
      )}
    </section>
  );
}
